import type { Locale } from '../content/site'

/** Russian has three plural forms: 1 проект, 3 проекта, 5 проектов. */
const russian = (count: number, [one, few, many]: readonly [string, string, string]): string => {
  const tens = count % 100
  const units = count % 10
  if (tens >= 11 && tens <= 14) return many
  if (units === 1) return one
  if (units >= 2 && units <= 4) return few
  return many
}

export const projectCount = (count: number, locale: Locale): string =>
  locale === 'ru'
    ? `${count} ${russian(count, ['проект', 'проекта', 'проектов'])}`
    : `${count} ${count === 1 ? 'project' : 'projects'}`
